<template>
  <div class="success-content">
    <div class="success-content-box flex-center-end">
      <img :src="img[type]" alt="">
      <div class="success-info" v-show="type==0">
        <p class="success-title flex-center">
          <i class="iconfont icongou"></i>
          恭喜您，签约成功！
        </p>
      </div>
      <div class="success-info" v-show="type==1">
        <p class="success-title flex-center audit-color">
          <i class="el-icon-warning"></i>
          您提交的资料审核中,请耐心等待！
        </p>
        <div class="success-text" style="width:90%">
          <p>审核结果我们会以短信的形式通知您，如有任何疑问，可致电400-626-8448联系客服。</p>
        </div>
      </div>
      <div class="success-info" v-show="type==2">
        <p class="success-title" style="width:70%;float:right;display:flex">
          <i class="el-icon-warning" style="color:red;transform: translateY(10px)"></i>
          抱歉，签约失败！请您联系客户经理处理
        </p>
      </div>
      <div class="success-info" v-show="type==3">
        <p class="success-title flex-center">
          <i class="iconfont icongou"></i>
          恭喜您，您的信息已审核通过！
        </p>
        <div class="success-text">
          <p>尊敬的合作伙伴，为双方旅游事业共同发展，进一步加强长期友好合作关系，请点击本界面按钮下载合同仔细阅读。本着诚实守信和互利原则，在平等自愿的基础上，确认内容无误后完成签约，感谢您的配合。</p>
          <el-checkbox v-model="auditStatu"></el-checkbox>
          <span>
            我已确认
            <span
              class="cursor"
              style="color:#237dc8"
              v-for="(item,index) in pdfUrl.fileResults"
              :key="index"
              @click="goPdf(item.downloadUrl)"
            >{{item.fileName}}</span>
          </span>
        </div>
      </div>
      <div class="success-info flex-center-end" v-show="type==4">
        <img :src="img[0]" alt="">
        <div>
          <p class="success-title flex-center">
            <i class="iconfont icongou"></i>
            恭喜您，信息提交成功！
          </p>
          <div class="success-text">
            <p>1.感谢您的注册，您提交的资料我们会第一时间审核</p>
            <p>2.审核结果我们会以短信的形式通知您</p>
            <p>3.您也可以用您注册的账号登录系统查看审核状态；</p>
            <p>4.如有任何疑问，可致电400-626-844联系客服</p>
          </div>
        </div>
      </div>
    </div>
    <div class="success-btn">
      <span @click="goPage" class="flex-center">
        {{btnText}}
        <b v-show="type==0">{{time}}</b>
      </span>
    </div>
  </div>
</template>
<script>
import buyerFileUpload from "@/lib/data-service/default/web_esIgn_esIgnSignerController_buyerFileUpload";
import supplierFileUpload from "@/lib/data-service/default/web_esIgn_esIgnSignerController_supplierFileUpload";
import supplierSign from "@/lib/data-service/default/web_esIgn_esIgnSignerController_supplierSign";
import buyerSign from "@/lib/data-service/default/web_esIgn_esIgnSignerController_buyerSign";
import supplierSignAcc from "@/lib/data-service/default/web_esIgn_esIgnSignerController_supplierSignAcc";
import buyerAcc from "@/lib/data-service/default/web_esIgn_esIgnSignerController_buyerAcc";
import get_user_info from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_user_info";
import get_url_prefix from 'yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix';
export default {
  data() {
    return {
      account: "",
      img: [
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/registration%20success.png?x-oss-process=style/webp",
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/audit.png?x-oss-process=style/webp",
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/error.png?x-oss-process=style/webp",
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/sign.png?x-oss-process=style/webp"
      ],
      //0 = 提交成功，1 = 审核中， 2 = 签约失败，3 = 审核成功
      type: 0,
      auditStatu: false,
      audit: false,
      btnText: "返回首页",
      accountType: 1, //1 2 供应商 ， 3 4 分销商 5 平台 6游客 7个人分销
      pdfUrl: "",
      time: 10
    };
  },
  methods: {
    goPage() {
      // let url = get_url_prefix({
      //   environment: global.appConfig.environment,
      //   appKey: "default"
      // });
      if (this.type != 3) {
        window.location.href = "/";
      } else {
        if (!this.auditStatu)
          return this.$message({
            type: "warning",
            message: "请阅读并勾选合同文件！"
          });
        this.signContract();
      }
    },
    async signContract() {
      let _this = this;
      if (this.accountType == 1 || this.accountType == 2) {
        try {
          let acc = await supplierSignAcc();
          let res = await supplierSign();
          window.open(res.url);
          this.goSuccess(0);
        } catch (error) {
          this.goSuccess(2);
        }
      } else if (
        this.accountType == 3 ||
        this.accountType == 4 ||
        this.accountType == 7
      ) {
        try {
          let acc = await buyerAcc();
          let res = await buyerSign();
          window.open(res.url);
          this.goSuccess(0);
        } catch (error) {
          this.goSuccess(2);
        }
      }
    },
    goSuccess(type) {
      this.$router.push({ path: `/register/success?type=${type}` });
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    },
    getPdf() {
      if (this.accountType == 1 || this.accountType == 2) {
        supplierFileUpload().then(res => {
          this.pdfUrl = res;
        });
      } else if (
        this.accountType == 3 ||
        this.accountType == 4 ||
        this.accountType == 7
      ) {
        buyerFileUpload().then(res => {
          this.pdfUrl = res;
        });
      }
    },
    setTime() {
      let count = setInterval(() => {
        this.time -= 1;
        if (this.time == 0) {
          this.time = 0;
          clearInterval(count);
          this.$router.push({ name: "redirect-to-user-front-home" });
        }
      }, 1000);
    },
    goPdf(url) {
      window.open(url);
    }
  },

  async created() {
    let type = (this.type = this.$route.query.type || 0);
    if (type == 3) {
      if (sessionStorage.getItem("pageShow")) {
        this.$router.push;
      }
      get_user_info().then(res => {
        console.log(res);
        this.accountType = res.userVo.userType;
        this.getPdf();
      });
      this.btnText = "完成签约";
    } else if (type == 0) {
      this.setTime();
    }
  }
};
</script>
<style lang="less" scoped>
.success-content {
  padding-top: 100px;
  .success-content-box {
    width: 1200px;
    margin: auto;
    img {
      width: 40%;
    }
    .success-info {
      // width: 90%;
      .success-title {
        font-size: 35px;
        font-weight: 400;
        letter-spacing: 5px;
        .icongou {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: linear-gradient(#aadf1f, #499008);
          font-size: 30px;
          color: white;
          text-align: center;
          margin-right: 10px;
          line-height: 45px;
          text-indent: 6px;
        }
      }
      .success-text {
        width: 70%;
        word-break: break-all;
        text-align: justify;
        margin: auto;
        font-size: 15px;
        color: #666;
        margin-top: 30px;
        p {
          margin-bottom: 10px;
        }
        ul {
          padding: 25px 40px;
          font-size: 15px;
          color: #333;
          li {
            list-style: none;
            padding: 5px 0;
          }
        }
      }
    }
  }
  .success-btn {
    padding: 100px 0;
    span {
      display: block;
      width: 150px;
      height: 35px;
      background: #237dc9;
      color: white;
      font-size: 15px;
      margin: auto;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
    }
  }
}
.audit-color {
  color: #fdae1e;
}
</style>
